const initials = "topFive/";
export const TOP_FIVE_PRODUCTS = `${initials}TOP_FIVE_PRODUCTS`;
